import React, { useState } from 'react'
import "./chart.scss"
import { EmptyChart, Eye, EyeOffBlack, MoreVertical } from 'assets'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const DashboardChart = ({ data }) => {
  const [isShow, setIsShow] = useState(false)

  const handleOnClick = () => {
    return setIsShow(!isShow)
  }

  function numberWithCommas(x) {
    const parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',');
  }

  const emptyChart = () => {
    return (
      <div className='empty-chart'>
        {data?.nominal ?
          <div style={{ width: "120px", paddingLeft: '15px' }}>
            <Doughnut data={data.data} />
          </div> :
          <div style={{padding: '0px 15px'}}>
            <EmptyChart />
          </div>
        }
        <div className='empty-info'>
          <div className='title-wrapper'>
            <span className='info-title'>{data?.title || 'Jenis Project'}</span>
            {/* <MoreVertical /> */}
          </div>
          <span className='info-subtitle'>{data?.subTitle || 'Nilai project saat ini'}</span>
          <div className='info-data'>
            <span>Rp {isShow ? numberWithCommas(data?.nominal || 0) : '***********'}</span>
            <div style={{ display: 'flex', cursor: 'pointer' }} onClick={handleOnClick}>
              {isShow ? <EyeOffBlack /> :
                <Eye />
              }
            </div>
          </div>
          {data && (
            <div className='label-wrapper'>
              {/* Nama dan angka dipisah jadi dua elemen. Sebelumnya keduanya
                  satu simpul teks ("0 Mechanical"), sehingga di kolom yang
                  sempit angkanya tertinggal di baris pertama dan namanya
                  turun ke baris kedua — bulatan warnanya lalu ikut melayang
                  di tengah dua baris itu. */}
              {data.chartLabel.map((value, index) => (
                <div className='chart-label' key={index}>
                  <span className='label-color' style={{ backgroundColor: `${value.color}` }}></span>
                  <span className='label-name'>{value.label}</span>
                  <span className='label-total'>{value.total}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className='chart-component'>
      {emptyChart()}
    </div>
  )
}

export default DashboardChart